<template>
  <div class="field">
    <input type="checkbox" :class="classObject" :checked="isOn" />
    <label for="Order Recieved" @click="handleChange"></label>
  </div>
</template>

<script>
export default {
  name: 'cw-switch',
  props: {
    disabled: { type: Boolean, required: false, default: false },
    type: { type: String, required: false, default: 'success' },
    size: { type: String, required: false, default: 'large' },
    name: { type: String, required: false, default: '' },
    isOn: { type: Boolean, required: true },
  },
  computed: {
    classObject() {
      const { type, size, isOn } = this;
      return {
        'switch': true, // eslint-disable-line
        'is-rounded': true,
        [`is-${type}`]: type,
        [`is-${size}`]: size,
        checked: isOn,
      };
    },
  },
  methods: {
    handleChange() {
      this.$emit('update:isOn', !this.isOn);
    },
  },
};
</script>

<style lang="stylus"></style>
